import styled from "styled-components";
import { breakpoints, maxBreakpoints } from "../../../../../../../shared-logic/themes/toyotaTheme";

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: var(--spacing-4);
    margin-top: calc(var(--spacing-3) / 2);
    padding: var(--spacing-4);
    background-color: var(--color-grey-1);

    @media screen and (min-width: ${breakpoints.xl}) {
        flex-direction: row;
        justify-content: space-between;
        row-gap: 0;
        height: 237px;
    }
`;

export const FrontView = styled.figure`
    display: flex;
    position: relative;
    flex-direction: column;
    row-gap: calc(var(--spacing-3) / 2);
    align-items: center;
    justify-content: flex-end;
    margin: 0;
    margin-inline-start: var(--spacing-3);

    @media screen and (max-width: ${maxBreakpoints.sm}) {
        svg {
            transform: scale(0.5);
        }
    }

    @supports not (margin-inline: 0) {
        margin-left: var(--spacing-3);
    }
`;

export const SideView = styled.figure`
    display: flex;
    flex-direction: column;
    row-gap: calc(var(--spacing-3) / 2);
    align-items: center;
    justify-content: flex-end;
    margin: 0;
    margin-inline-end: var(--spacing-3);

    @supports not (margin-inline: 0) {
        margin-right: var(--spacing-3);
    }
`;

export const CarHeight = styled.div`
    position: absolute;
    top: 50%;
    inset-inline-start: calc(var(--spacing-6) * -1);
    text-align: center;
    transform: translateY(-50%) rotate(270deg);
    transform-origin: center;

    @supports not (inset-inline: 0) {
        left: calc(var(--spacing-6) * -1);
    }
`;
